'use strict';

var mapValues = require('lodash.mapvalues');
var renameField = require('./rename-field');
var mergeObjects = require('./merge-objects');

var encoders = [function encodeHead() {
  return { V: '2', P: 'jobsearch' };
}, renameField('keywords', 'K'), renameField('where', 'WH'), renameField('whereid', 'WID'), renameField('classification', 'I'), renameField('subclassification', 'O'), renameField('sortmode', 'SORT'), function encodeSalaryType(query) {
  var value = query.salarytype;

  if (!value) {
    return {};
  }

  return value === 'hourly' ? { SFT: 'SalaryHourly', SL: 'Hourly' } : { SFT: 'Salary', SL: 'Annual' };
}, function encodeSalary(query) {
  if (!query.salaryrange || !/\d*-\d*/.test(query.salaryrange)) {
    return {};
  }

  var salaryParts = query.salaryrange.split('-');

  return {
    SF: salaryParts[0] || '0',
    ST: salaryParts[1] || '999999'
  };
}, renameField('daterange', 'D'), renameField('worktype', 'W'), renameField('page', 'N'), renameField('companyid', 'CID'), renameField('nation', 'NA'), renameField('location', 'L'), renameField('area', 'A'), renameField('advertiserid', 'ADV'), renameField('advertisergroup', 'ADG'), function encodeGraduateSearch(query) {
  var value = query.graduatesearch;

  return value === 'true' ? { C: '1' } : {};
}, function encodeTail(query, date) {
  return { OSF: 'quick&set=' + date.getTime() };
}];

module.exports = function (date, query) {
  var encodedParts = encoders.map(function (encode) {
    return encode(query, date);
  });

  var cookieObject = mergeObjects(encodedParts);
  var encodedCookieObject = mapValues(cookieObject, function (value, key) {
    return key === 'OSF' ? value : encodeURIComponent(value);
  });

  return Object.keys(encodedCookieObject).map(function (key) {
    return key + encodeURIComponent('|') + encodedCookieObject[key].split('~')[0];
  }).join('~');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/last-search-cookie/encode.js
 ** module id = 452
 ** module chunks = 0
 **/